export default "__VITE_ASSET__b83f9fb7__"